import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setColor,
  setSubTitleTemplate,
} from "../../store/Subtitle/subTitleSlice";

const SubTitlePopover = () => {
  const dispatch = useDispatch();
  const { subtitles } = useSelector((state) => state.script);
  const { subTitleTemplate = {} } = useSelector((state) => state.subTitle);
  const handleColorChange = async (color) => {
    dispatch(setColor(color));
  };
  return (
    <div className="w-full">
      <div className="flex items-center pl-[25px]  h-[56px] font-medium bg-gradient-sidebar">
        Subtitle Style
      </div>
      <div className="pl-[26px] pr-4">
        <div className="flex gap-1 items-center my-2 h-[20px]">
          <img
            src={"/tool/dashboard/static/images/icons/subtitle/alert-circle.svg"}
          />
          <span className="font-semibold text-[#11142D80] ">
            Please Note: The style will be applied to all slides
          </span>
        </div>
        <div className="h-[308px] overflow-auto rounded-lg bg-white border border-[#0000004D] pt-[13px] px-[18px] flex flex-wrap gap-x-5 gap-y-[18px]">
          {subtitles.map((sub, index) => {
            return (
              <div
                className={`w-[140px] rounded-lg cursor-pointer overflow-hidden  ${
                  subTitleTemplate?.id === sub?.id
                    ? "bg-gradient p-[2px]"
                    : "bg-white p-[2px]"
                }`}
                onClick={() => dispatch(setSubTitleTemplate(sub))}
              >
                <img
                  className="h-[80px] w-full rounded-lg overflow-hidden"
                  src={sub?.previews?.previewGif}
                />
              </div>
            );
          })}
        </div>
        {/** color */}

        <div className="relative flex items-center gap-2 p-2">
          Select Color
          <input
            type="color"
            className="border  w-8 h-9"
            // style={{ padding: "-10px" }}
            onChange={(e) => handleColorChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default SubTitlePopover;
